import React, { Component } from 'react';
import chunk from 'lodash/chunk';
import PropTypes from 'prop-types';
import AreaSelector from './AreaSelector';
import AreaAndRegionSelector from './AreaAndRegionSelector';
import RegionToggle from './RegionToggle';
import FlexCarousel from './FlexCarousel';
import AreaItem from './AreaItem';
import styles from './ExploreByArea.scss';
import { generateSearchUrl } from '../../../shared/model/transformers/srpSearchConditionUrlGenerator';
import {
  ALL_AREAS,
  getItemsForArea,
  getItemsForButtons,
  getItemsForToggle,
  getAreaAndRegionItems,
  getCurrentAreaAndRegionItem,
} from '../constants/exploreByAreaOptions';
import { CHANNEL_PROP_TYPES } from '../../../shared/model/types';
import { withUserAgent } from '../../../shared/userAgentContext';
import trackingAdapter from '../tracking/trackingAdapter';

export class ExploreByArea extends Component {
  state = {
    currentArea: ALL_AREAS.ALL_STATES.id,
    currentRegion: getItemsForToggle(ALL_AREAS.ALL_STATES.id)[0],
  };

  setRegion = (region) => {
    this.setState({ currentRegion: region });
    trackingAdapter.trackAreaAndRegionSelectorClick({
      channelObject: this.props.currentChannel,
      areaId: this.state.currentArea,
      regionId: region,
    });
  };

  changeAreaAndRegion = (areaId, regionId) => {
    const finalRegionId = regionId || getItemsForToggle(areaId)[0];

    this.setState({
      currentArea: areaId,
      currentRegion: finalRegionId,
    });

    trackingAdapter.trackAreaAndRegionSelectorClick({
      channelObject: this.props.currentChannel,
      areaId,
      regionId: finalRegionId,
    });
  };

  buildSearchResultPageUrl = (currentChannel, searchLocations) => {
    const searchUrl = generateSearchUrl({
      channel: currentChannel.url,
      locations: searchLocations,
    });

    return searchUrl.pathname;
  }

  renderItems = (
    isMobile,
    areaItems = [],
    currentChannel,
    currentArea,
  ) => (
    isMobile
      ? chunk(areaItems, 2)
        .map((group, groupIndex) => (
          <div key={`double-decker-item-key-${groupIndex}`}>
            {
              group.map(areaItem => (
                <AreaItem
                  areaItemClassName={styles.mobileCarouselItem}
                  key={`${currentArea}-${areaItem.title}`}
                  title={areaItem.title}
                  description={areaItem.description}
                  image={areaItem.bgImg}
                  href={
                    this.buildSearchResultPageUrl(
                      currentChannel,
                      areaItem.searchLocations,
                    )
                  }
                  trackClick={() => trackingAdapter.trackAreaItemClick({ channelObject: currentChannel, itemId: areaItem.omnitureItemId })}
                />
              ))
            }
          </div>
        ),
        )
      : areaItems.map(areaItem => (
        <AreaItem
          areaItemClassName={styles.desktopCarouselItem}
          key={`${currentArea}-${areaItem.title}`}
          title={areaItem.title}
          description={areaItem.description}
          image={areaItem.bgImg}
          href={
              this.buildSearchResultPageUrl(
                currentChannel,
                areaItem.searchLocations,
              )
            }
          trackClick={() => trackingAdapter.trackAreaItemClick({ channelObject: currentChannel, itemId: areaItem.omnitureItemId })}
        />
      ))
  );

  render() {
    const { currentChannel, isMobile } = this.props;
    const { currentArea, currentRegion } = this.state;
    const buttonItems = getItemsForButtons();
    const toggleItems = getItemsForToggle(currentArea);
    const regionKey = currentRegion || toggleItems[0];
    const areaItems = getItemsForArea(currentArea)[regionKey];
    const areaAndRegionItems = getAreaAndRegionItems();
    const currentAreaAndRegionItem = getCurrentAreaAndRegionItem(areaAndRegionItems, currentArea, currentRegion);

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Explore by area</h2>
          <AreaSelector
            currentArea={currentArea}
            items={buttonItems}
            changeAreaAndRegion={this.changeAreaAndRegion}
          />
          <RegionToggle
            options={toggleItems}
            currentRegion={currentRegion}
            setRegion={this.setRegion}
          />
          <AreaAndRegionSelector
            currentAreaAndRegionItem={currentAreaAndRegionItem}
            items={areaAndRegionItems}
            changeAreaAndRegion={this.changeAreaAndRegion}
          />
        </div>
        <FlexCarousel
          shiftBy={1}
          key={`${currentArea}${currentRegion}`}
        >
          { this.renderItems(
            isMobile,
            areaItems,
            currentChannel,
            currentArea,
          )
          }
        </FlexCarousel>
      </div>
    );
  }
}

ExploreByArea.propTypes = {
  currentChannel: CHANNEL_PROP_TYPES.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default withUserAgent(['isMobile'])(ExploreByArea);
